import type {
  AssignedProjectsState,
} from 'app/store/login/assigned-projects/assigned-projects.reducer';
import type { LoggedUserState } from 'app/store/login/logged-user/logged-user.state';
import { createFeatureSelector } from '@ngrx/store';
import {
  initialAssignedStateState,
} from 'app/store/login/assigned-projects/assigned-projects.reducer';
import { initialLoggedUserState } from 'app/store/login/logged-user/logged-user.state';

export const loginFeatureKey = 'login';

export const selectLoginState = createFeatureSelector<LoginState>(loginFeatureKey);

export interface LoginState {
  assignedProjects: AssignedProjectsState;
  loggedUser: LoggedUserState;
}

export const initialLoginState: LoginState = {
  assignedProjects: initialAssignedStateState,
  loggedUser: initialLoggedUserState,
};
